import { createTheme, ThemeOptions } from "@mui/material/styles";

const themeOptions: ThemeOptions = {
  palette: {
    mode: "dark",
    primary: {
      main: "#8b5cf6",
      light: "#a78bfa",
      dark: "#7c3aed",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#6366f1",
      light: "#818cf8",
      dark: "#4f46e5",
      contrastText: "#ffffff",
    },
    background: {
      default: "#0b0f17",
      paper: "#0f172a",
    },
    text: {
      primary: "#f1f5f9",
      secondary: "#94a3b8",
    },
    divider: "rgba(148, 163, 184, 0.16)",
    success: { main: "#34d399" },
    warning: { main: "#fbbf24" },
    error: { main: "#f43f5e" },
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
    h1: { fontWeight: 800, letterSpacing: "-0.02em" },
    h2: { fontWeight: 800, letterSpacing: "-0.02em" },
    h3: { fontWeight: 700, letterSpacing: "-0.01em" },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#0b0f17",
          color: "#f1f5f9",
          scrollBehavior: "smooth",
        },
        "::selection": {
          backgroundColor: "#8b5cf6",
          color: "#ffffff",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          textTransform: "none",
          padding: "10px 20px",
          fontWeight: 600,
        },
        contained: {
          boxShadow: "0 10px 25px rgba(124, 58, 237, 0.25)",
          backgroundImage: "linear-gradient(90deg, #7c3aed 0%, #4f46e5 100%)",
          "&:hover": {
            boxShadow: "0 12px 28px rgba(124, 58, 237, 0.35)",
            backgroundImage:
              "linear-gradient(90deg, #8b5cf6 0%, #6366f1 100%)",
          },
        },
        outlined: {
          borderWidth: "1px",
          borderColor: "rgba(148, 163, 184, 0.3)",
          color: "#e2e8f0",
          "&:hover": {
            borderWidth: "1px",
            borderColor: "#8b5cf6",
            backgroundColor: "rgba(139, 92, 246, 0.08)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: "rgba(15, 23, 42, 0.9)",
          border: "1px solid rgba(51, 65, 85, 0.8)",
          borderRadius: "16px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderColor: "rgba(139, 92, 246, 0.35)",
        },
        outlined: {
          color: "#c4b5fd",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "#0f172a",
          border: "1px solid rgba(51, 65, 85, 0.9)",
          backgroundImage: "none",
        },
      },
    },
  },
};

const theme = createTheme(themeOptions);

export default theme;
